<script>
  import HitApi from '@/services/Api/HitApi'
  import HitCard from '@/components/Hit/HitCard'

  export default {
    components: {
      HitCard
    },

    data() {
      return {
        menu_open: false,
        hits: []
      }
    },

    created() {
      HitApi.getLatest()
        .then(hits => (this.hits = hits))
    }
  }
</script>

<template>
  <main class="Home">
    <section class="Home_intro has-text-centered">
      <nav class="navbar is-transparent">
        <div class="navbar-brand">
          <!-- <a class="navbar-item is-toggle">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a> -->

          <router-link class="navbar-item" :to="{name: 'home'}">
            <img src="../assets/img/logo_small.svg" alt="The Warmup">
          </router-link>

          <button class="button navbar-burger is-transparent is-flat" @click="menu_open = !menu_open">
              <i class="fa fa-bars" aria-hidden="true"></i>
          </button>
        </div>

        <div class="navbar-end navbar-menu" :class="{'is-active': menu_open}">
          <a class="navbar-item"
            v-scroll-to="{el: '#what', offset: 20}"
            @click="menu_open = false">
            Qu'est-ce que c'est ?
          </a>
          <a class="navbar-item"
            v-scroll-to="{el: '#lastest-hits', offset: 20}"
            @click="menu_open = false">
            Les derniers hits des players
          </a>
          <div class="navbar-item">
            <router-link class="button is-outlined is-danger is-flat" :to="{name: 'login'}">
              Se connecter
            </router-link>
          </div>
        </div>
      </nav>

      <h1 class="title is-size-4-touch is-size-2-desktop">Le terrain d'entraînement des étudiants du digital</h1>

      <p class="is-size-7-mobile">
        Tu es étudiant en digital ou en multimédia ? <br> Partage tes réalisations et améliore-toi grâce aux feedbacks des autres étudiants.
      </p>

      <div class="Home_cta">
        <router-link class="button is-warning"
          :to="{name: 'register'}"
          @click.native="$trackEventBasic('Home', 'click register', 'intro')">
          Inscris-toi
        </router-link>
      </div>
    </section>

    <section class="Home_schools">
      <figure class="Home_schools_preview"><img src="../assets/img/app-preview.png"></figure>

      <div class="Home_schools_content">
        <h2>Déjà plusieurs écoles disponibles</h2>
        <img src="../assets/img/schools/hetic.png">
        <img src="../assets/img/schools/eemi.png">
        <img src="../assets/img/schools/epitech.png">
        <img src="../assets/img/schools/efreitech.png">
        <img src="../assets/img/schools/webschool_factory.jpg">
      </div>
    </section>

    <section class="Home_what has-text-centered" id="what">
      <h2 class="title is-size-3-desktop is-size-5-touch">The Warmup, c'est une plateforme pour...</h2>

      <div class="columns content">
        <article class="column">
          <figure>
            <img src="../assets/img/illus/share.png">
          </figure>

          <h3>Partager tes réalisations</h3>
          <p>
            Code, vidéo, design ou toute autre réalisation numérique sont partagés avec une communauté d'étudiants venant de diverses écoles.
          </p>
        </article>

        <article class="column">
          <figure>
            <img src="../assets/img/illus/feedback.png">
          </figure>

          <h3>Obtenir des feedbacks</h3>
          <p>
            Tous les players, quelles que soient leurs spécialisations et leurs compétences, te font des feedbacks et te laissent des commentaires.
          </p>
        </article>

        <article class="column">
          <figure>
            <img src="../assets/img/illus/cards.png">
          </figure>

          <h3>Progresser</h3>
          <p>
            Grâce à la communauté, tu t'améliores et tu montes en compétence. Leurs commentaires sont le meilleur moyen pour toi de progresser !
          </p>
        </article>
      </div>

      <figure class="Home_what_illus columns">
        <div class="column">
          <img src="../assets/img/catcher.png">
        </div>
        <div class="column">
          <img src="../assets/img/illu-2.png">
        </div>
        <div class="column">
          <img src="../assets/img/illu-1.png">
        </div>
      </figure>
    </section>

    <section class="Home_hits" id="lastest-hits">
      <h2 class="title is-size-3-desktop is-size-5-touch has-text-centered">Les derniers hits des players</h2>

      <div class="columns is-multiline">
        <div class="column is-half" v-for="hit in hits" :key="hit.id">
          <hit-card
            :player="hit.player"
            :hit="hit"
            :is-public="true"
            :show-date="false">
          </hit-card>
        </div>
      </div>

      <div class="Home_cta has-text-centered">
        <router-link class="button is-warning"
          :to="{name: 'register'}"
          @click.native="$trackEventBasic('Home', 'click register', 'latest hits')">
          Inscris-toi
        </router-link>

        <!-- <a href="https://docs.google.com/forms/d/e/1FAIpQLSdV8fDG_u4auTCNUGr-RpgTCu5m-eKsdRLnCcffBNvlSVLU6A/viewform"
          target="_blank"
          class="button is-outlined is-primary is-flat">Ajoute ton école</a> -->
      </div>
    </section>

    <footer class="Home_footer has-text-centered">
      <figure><img src="../assets/img/big-logo.png"></figure>

      <h2 class="title is-size-3-desktop is-size-5-touch">The Warmup, l'échauffement commence ici !</h2>
      <p>Rejoins tous les étudiants qui font partie du game</p>

      <div class="Home_cta">
        <router-link class="button is-info"
          :to="{name: 'register'}"
          @click.native="$trackEventBasic('Home', 'click register', 'footer')">
          Inscris-toi
        </router-link>

        <!-- <a href="https://docs.google.com/forms/d/e/1FAIpQLSdV8fDG_u4auTCNUGr-RpgTCu5m-eKsdRLnCcffBNvlSVLU6A/viewform"
          target="_blank"
          class="button is-outlined is-danger is-flat">Ajoute ton école</a> -->
      </div>
    </footer>
  </main>
</template>

<style lang="scss">
  @import '~bulma/sass/utilities/all';

  .Home {
    .button.is-outlined {
      color: $grey-darker;
      border-color: $grey-darker;
    }

    .navbar {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: transparent;

      @include touch() {
        background: #fff;

        &-brand {
          justify-content: space-between;
        }
      }

      &-item:hover {
        background: none;
      }

      &-burger {
        padding: 0;
        margin: 0;
        background: none;
      }

      .button {
        margin: 0;

        &.is-transparent {
          border: 0;

          &:focus {
            box-shadow: none;
          }

          .fa {
            font-size: 22px;
          }
        }
      }
    }

    &_intro {
      padding: pxToEm(150) pxToEm(20) pxToEm(300);
      background: url('../assets/img/bg-banner-home.jpg') repeat;

      h1,
      p {
        max-width: 600px;
        margin: 0 auto;
      }

      h1 {
        margin-bottom: pxToEm(20);
      }

      p {
        font-size: $font-size-m;
      }

      .button {
        margin-top: pxToEm(30);
      }

      @include touch() {
        padding-bottom: pxToEm(100);
      }
    }

    &_cta {
      margin-top: pxToEm(20);

      .button {
        margin: 0 pxToEm(10);
      }

      @include mobile() {
        .button {
          display: block;
          
          &:not(:last-child) {
            margin-bottom: pxToEm(10);
          }
        }
      }
    }

    &_schools {
      position: relative;
      padding-bottom: pxToEm(40);
      padding-top: pxToEm(290);
      background: $grey-lightest;

      &_preview img {
        position: absolute;
        display: block;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0 24px 40px 3px rgba(0, 0, 0, 0.2);
      }

      &_content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;

        h2,
        img {
          flex: 0 0 auto;
          display: block;
          margin: pxToEm(10);
        }

        h2 {
          font-weight: 700;
        }
      }

      @include touch() {
        padding: pxToEm(40);

        &_preview {
          display: none;
        }

        &_content h2 {
          margin: 0;
        }
      }
    }

    &_what {
      margin-bottom: -80px;
      padding: pxToEm(50) pxToEm(20) 0;
      background: #fff;

      .title {
        margin-bottom: pxToEm(50);
        padding: 0 pxToEm(20);
      }

      figure {
        height: 210px;

        img {
          max-height: 100%;
        }
      }

      h3 {
        text-align: left;
      }

      p {
        text-align: justify;
        color: $grey;
      }

      .columns {
        max-width: 1200px;
        margin: 0 auto pxToEm(40);
      }

      .column {
        padding: 0 pxToEm(20);
      }

      &_illus.columns {
        max-width: 540px;
        align-items: flex-end;

        .column {
          padding: 0 pxToEm(25);

          &:nth-child(1) img {
            max-height: 140px;
          }

          &:nth-child(2) img {
            max-height: 180px;
          }

          &:nth-child(3) img {
            max-height: 170px;
          }
        }
      }

      @include touch() {
        overflow: hidden;
        margin-bottom: 0;
        padding-left: 0;
        padding-right: 0;

        figure {
          margin: 0;
        }
      }

      @include mobile() {
        figure {
          height: auto;
        }

        &_illus.columns {
          display: none;
        }

        .column {
          padding: pxToEm(25);
        }
      }
    }

    &_hits {
      padding: pxToEm(80) pxToEm(20) pxToEm(40);
      background: $grey-lightest;

      .columns {
        max-width: $desktop;
        margin: auto;
      }

      .column {
        display: flex;
      }

      @include mobile() {
        padding: pxToEm(20) 0;

        .column:nth-child(3),
        .column:nth-child(4) {
          display: none;
        }
      }
    }

    &_footer {
      padding: pxToEm(60) pxToEm(20);
      background: url('../assets/img/bg-banner-home-last.jpg') repeat;

      figure img {
        max-height: 140px;
        margin-bottom: pxToEm(30);
      }

      p {
        font-size: $font-size-m;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PageHome.vue?13bf1c82